import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = `https://swiftlogo-v2-utpn6iuzbq-uc.a.run.app/api/`

export const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        const accessToken = getState()?.app?.user?.accessToken;

        if (accessToken) {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }

        return headers;
    },
});